import styled from '@emotion/styled'
// import { LogoSticky } from 'app/components/Icons'
import { AnimatePresence, motion } from 'framer-motion'
import React, { memo, ReactNode, useEffect, useState } from 'react'

interface Props {
  children: ReactNode
  location: any
}

export const Transition = memo(function Transition({
  children,
  location,
}: Props) {
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    history.scrollRestoration = 'manual'
  }, [])

  const variants = {
    visible: {
      opacity: 1,
      zIndex: 10000,
      transition: {
        duration: 0.4,
        ease: [0.22, 1, 0.36, 1],
      },
    },
    hidden: {
      opacity: 0,
      zIndex: -1,
      transition: {
        delay: 1,
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1],
        zIndex: {
          delay: 1.2,
        },
      },
    },
  }

  return (
    <AnimatePresence mode="wait">
      <Main key={location.pathname}>
        <Aside
          className={loaded ? 'loaded' : undefined}
          initial="visible"
          animate="hidden"
          exit="visible"
          onAnimationStart={() => setLoaded(true)}
          onAnimationComplete={() => setLoaded(false)}
          variants={variants}
        >
          <Wrap>
            {/* <LogoSticky />
            <LogoSticky /> */}
          </Wrap>
        </Aside>

        {children}
      </Main>
    </AnimatePresence>
  )
})

const Main = styled(motion.main)``

const Wrap = styled.div`
  svg {
    width: 10rem;
    height: auto;
    fill: ${({ theme }) => theme.colors.variants.neutralDark2};
    position: absolute;
    top: calc(50% - 3.75rem);
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    &:last-of-type {
      clip-path: inset(100% 0% 0% 0%);
      fill: ${({ theme }) => theme.colors.variants.primaryLight};
    }

    path {
      fill: unset;
    }
  }

  @media (max-width: 1199px) {
    svg {
      width: 7.5rem;
    }
  }
`

const Aside = styled(motion.aside)`
  width: 100%;
  height: 100vh;
  background: ${({ theme }) => theme.colors.variants.primaryDark};
  position: fixed;
  top: 0;
  left: 0;
  &.loaded {
    ${Wrap} {
      svg {
        &:last-of-type {
          clip-path: inset(0);
          transition: 0.8s 0.2s ease-in-out;
        }
      }
    }
  }
`
